import {   useMemo, useState,useEffect } from "react";
import axios from "../../../services/axiosInstance";
import { toast } from "react-toastify";
import { ProfileData } from "../types/profileTypes";

 

export const useProfile = () => {

  const [profileData, setProfileData] = useState<ProfileData>({
    nom: "",
    email: "",
    roles: "User",
    password: "",
    isVerified: false,
    photoUrl: "",
  });

  const [editData, setEditData] = useState<ProfileData>(profileData);

  const [userId] = useState<number | null>(null);
  const [isAdmin] = useState(false);
const [loading, setLoading] = useState(true);
  const [isEditing, setIsEditing] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");

 
 
  const handleInputChange = (
    field: keyof ProfileData,
    value: string | boolean
  ) => {

    setEditData((prev) => ({
      ...prev,
      [field]: value,
    }));

  };

  useEffect(() => {
  const fetchProfile = async () => {
    try {
      const res = await axios.get("/api/me");
 
      setProfileData(res.data);
      setEditData(res.data);

    } catch (error) {
       toast.error("Erreur lors du chargement du profil");
    } finally {
       setLoading(false);
    }
  };

  fetchProfile();
}, []);
 
  const handleSave = async () => {

    if (!userId) return;

    const payload: Record<string, any> = {};

    if (editData.password) {

      if (editData.password !== confirmPassword) {
        toast.error("Les mots de passe ne correspondent pas.");
        return;
      }

    }

    if (editData.nom !== profileData.nom)
      payload.nom = editData.nom;

    if (editData.password && editData.password !== "********")
      payload.password = editData.password;

    if (isAdmin && editData.isVerified !== profileData.isVerified)
      payload.isVerified = editData.isVerified;

    if (Object.keys(payload).length === 0) {
      setIsEditing(false);
      return;
    }

    try {

      await axios.put(`/api/users/${userId}`, payload);

      const updated = {
        ...editData,
        password: "********",
      };

      setProfileData(updated);
      setEditData(updated);

      setConfirmPassword("");
      setIsEditing(false);

      toast.success("Profil mis à jour.");

    } catch (e: any) {

      const status = e?.response?.status;

      if (status === 409) toast.error("Email déjà utilisé.");
      else if (status === 403) toast.error("Action non autorisée.");
      else toast.error("Échec de la mise à jour.");

    }

  };

 
  const handleCancel = () => {

    setEditData(profileData);
    setIsEditing(false);

  };

 
 
 
  const profileSlug = useMemo(() => {
    if (!profileData.nom) return "";

    return profileData.nom
      .trim()
      .toLowerCase()
      .replace(/\s+/g, "-");

  }, [profileData.nom]);

  return {
    profileData,
    editData,
    loading,
    isEditing,
    confirmPassword,
    isAdmin,
    profileSlug,
    setIsEditing,
    setConfirmPassword,
    handleInputChange,
    handleSave,
    handleCancel,
   };
};